// import React, { useEffect } from "react";
// import {
//   Button,
//   FormFieldSet,
//   Modal,
//   NewTable,
//   useFormHandler,
// } from "../../../../../components";
// import { dateFormator } from "../../../../../utils";

// const SalaryprofileConfigurationsModal = ({
//   onClose,
//   isOpen,
//   isEditMode,
//   initialData,
// }) => {
//   const { formData, errors, handleChange, validateAllFields, setFormData } =
//     useFormHandler(
//       {
//         profileName: "",
//         payCycle: "",
//         lastDayOfthePayCycle: "",
//         payDay: "",
//         employeePayableDays:
//           "All days in paycycle are payable (weekends and holidays are paid)",
//       },
//       {
//         profileName: { type: "text", required: true },
//       }
//     );

//   useEffect(() => {
//     if (isEditMode && initialData) {
//       setFormData({
//         profileName: initialData.payProfileName || "",
//         payCycle: initialData.payCycle || "",
//         lastDayOfthePayCycle: "", // add correct mapping
//         payDay: initialData.payDay || "",
//         employeePayableDays: "", // update if needed
//       });
//     }
//   }, [isEditMode, initialData]);

//   const handleSave = () => {
//     const isValid = validateAllFields();
//     if (isValid) {
//       console.log("form data:", formData);
//       onClose();
//     } else {
//       console.log("error:", errors);
//     }
//   };

//   const tableData = [
//     {
//       payPeriods: "03/23/2025 - 03/29/2025",
//       actualPayDays: "04/05/2025",
//     },
//   ];
//   const columns = [
//     {
//       key: "payPeriods",
//       label: "Pay Periods",
//     },
//     {
//       key: "actualPayDays",
//       label: "Actual Pay Days",
//       render: (row) => dateFormator(row.actualPayDays, "month-day-year"),
//     },
//     {
//       key: "payDays",
//       label: "Pay Days",
//       render: (row) => dateFormator(row.payDays, "month-day-year"),
//     },
//   ];

//   return (
//     <Modal
//       title={"Salary profile configurations"}
//       onClose={onClose}
//       isOpen={isOpen}
//       width="max-w-6xl"
//     >
//       <div>
//         <div className="grid grid-cols-2 mt-4 gap-x-6 gap-y-4 max-w-3xl">
//           <FormFieldSet
//             type="text"
//             title={"Profile Name"}
//             placeholder="Enter Profile Name"
//             value={formData.profileName}
//             onChange={(value) => handleChange("profileName", value)}
//             error={errors.profileName}
//           />
//           <FormFieldSet
//             type="select"
//             title={"Pay Cycle"}
//             placeholder="Enter Invoice Note"
//             value={formData.payCycle}
//             onChange={(value) => handleChange("payCycle", value)}
//             error={errors.payCycle}
//             disabled={isEditMode}
//           />
//           <FormFieldSet
//             type="datepicker"
//             title={"Last Day of the Pay Cycle"}
//             placeholder="Enter Invoice Note"
//             value={formData.lastDayOfthePayCycle}
//             onChange={(value) => handleChange("lastDayOfthePayCycle", value)}
//             error={errors.lastDayOfthePayCycle}
//           />
//           <FormFieldSet
//             type="datepicker"
//             title={"Pay Day"}
//             placeholder="Select Pay Day"
//             value={formData.payDay}
//             onChange={(value) => handleChange("payDay", value)}
//             error={errors.payDay}
//           />
//         </div>
//         <div className="">
//           <p className="mt-3">
//             In case of salaried employees how do you calculate the pay cycle’s
//             payable days ?
//           </p>

//           <div>
//             <FormFieldSet
//               type="radio"
//               title={""}
//               placeholder="Select Pay Day"
//               options={[
//                 {
//                   value:
//                     "All days in paycycle are payable (weekends and holidays are paid)",
//                   label:
//                     "All days in paycycle are payable (weekends and holidays are paid)",
//                 },
//                 {
//                   value:
//                     "Only working days are payable (weekends and holidays are not paid)",
//                   label:
//                     "Only working days are payable (weekends and holidays are not paid)",
//                 },
//                 {
//                   value:
//                     "Only working days and calendar holidays are payable (Weekends not paid)",
//                   label:
//                     "Only working days and calendar holidays are payable (Weekends not paid)",
//                 },
//               ]}
//               value={formData.employeePayableDays}
//               name="Payble days"
//               onChange={(event) =>
//                 handleChange("employeePayableDays", event.target.value)
//               }
//               className={"flex-col"}
//             />
//           </div>
//           <div>
//             <p className="mt-4">
//               Coming Pay Days and Pay Periods based on the configurations
//             </p>
//           </div>
//         </div>

//         <NewTable
//           rows={tableData}
//           columns={columns}
//           toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
//         />
//         <div className="flex gap-3 justify-end my-8">
//           <Button title="Cancel" variant="outlined" onClick={onClose} />
//           <Button
//             title={`${isEditMode ? "Update" : "Create"}`}
//             onClick={() => handleSave()}
//           />
//         </div>
//       </div>
//     </Modal>
//   );
// };

// export default SalaryprofileConfigurationsModal;

import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  NewTable,
  useFormHandler,
} from "../../../../../components";
import { dateFormator } from "../../../../../utils";
import { SalaryProfileCycles, TimesheetCycles } from "../../../../../assets/data/enumData";
import { useDispatch, useSelector } from "react-redux";
import { addNewSalaryPayConfig, getAllSalaryPayConfig } from "../../../../../redux/slices/payroll/payrollSlice";
import { filterEmptyValues } from "../../../../../utils/filterEmptyValues";
import { useLoginUser } from "../../../../../hooks/useLoginUser";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";

const SalaryprofileConfigurationsModal = ({
  onClose,
  isOpen,
  isEditMode,
  initialData,
  onSave, // ✅ New prop
  handleLimitChange,
  setPage,
}) => {
   const { userData: loginUserData } = useLoginUser();
    const organizationId = loginUserData?.organizationId.uiid;
    const loginUserUiid = loginUserData?.uiid;
  const dispatch = useDispatch();
  const {loading,salaryPayConfig}=useSelector((state)=>state.payRoll);
  const isLoading=!!loading
 const defaultValues={
    profileName: "",
        payCycle: "",
        lastDayOfthePayCycle: "",
        payDay: "",
        employeePayableDays: "",
 }
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      defaultValues,
      {
        profileName: { type: "text", required: true },
        payCycle: { type: "select", required: true },
      }
    );
const handleCancelData=()=>{
  onClose()
  setFormData(defaultValues)
}
  // useEffect(() => {
  //   if (!isOpen) return; // Only run when modal is opened

  //   if (isEditMode && initialData) {
  //     setFormData({
  //       profileName: initialData.payProfileName || "",
  //       payCycle: initialData.payCycle || "",
  //       lastDayOfthePayCycle: "", // update if needed
  //       payDay: initialData.payDay || "",
  //       payableDaysConfig: initialData.employeePayableDays || "",
  //     });
  //   } else {
  //     // Clear form for Add mode every time modal opens
  //     setFormData({
  //       profileName: "",
  //       payCycle: "",
  //       lastDayOfthePayCycle: "",
  //       payDay: "",
  //       employeePayableDays:
  //         "All days in paycycle are payable (weekends and holidays are paid)",
  //     });
  //   }
  // }, [isOpen, isEditMode, initialData]);

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      let payload = {
        name: formData.profileName,
        payCycle: formData.payCycle,
      };
      if(!isEditMode){
        payload.status=1
        payload.addedBy=loginUserUiid
      }else{
        payload=[{
            "type": "SET",
            "value": {
                name: formData.profileName,
               payCycle: formData.payCycle,
            }
        }]
      }
      // ✅ Clean data
         const submissionData = filterEmptyValues(payload);
      dispatch(
  addNewSalaryPayConfig({
    coll: "SalaryProfile",
    payload: submissionData,
   ...(isEditMode && { uiid: initialData?.uiid }),
    onSuccess: () => {
      handleCancelData();
      setPage(1);
      handleLimitChange(10);
       dispatch(
                totalCountStart({
                  collection: "salaryprofiles",
                  coll: "SalaryProfile",
                  tname: "salaryprofile",
                })
              );
              dispatch(
                getAllSalaryPayConfig({
                  coll: "SalaryProfile",
                  limit:10,  // Make sure 'limit' and 'page' are defined or passed in the context
                  page:1,
                })
              );
    },
  })
);

      // onSave(payload); // ✅ Update parent
    }
  };
  const [tableData, setTableData] = useState([]);
  console.log("tableData", tableData);
  // const tableData = [
  //   {
  //     payPeriods: "03/23/2025 - 03/29/2025",
  //     actualPayDays: "04/05/2025",
  //   },
  // ];
  const columns = [
    {
      key: "payPeriods",
      label: "Pay Periods",
    },
    {
      key: "payDays",
      label: "Pay Days",
      render: (row) => dateFormator(row.payDays, "month-day-year"),
    },
  ];
  const handleLastDayOfThePayCycle = (value) => {
    console.log("value", value);

    handleChange("lastDayOfthePayCycle", value);
    if (!value) {
      handleChange("payDay", "");
      setTableData([]);
      return "";
    }
    const selectedDate = new Date(value);
    const dayOfMonth = selectedDate.getDate();
    const newTableData = [];

    let periodEnd = new Date(selectedDate);

    const formatDateLocal = (date) => date.toLocaleDateString("en-CA");

    const getSafeDate = (year, month, day) => {
      const date = new Date(year, month, day);
      return date.getDate() !== day ? new Date(year, month + 1, 0) : date;
    };

    for (let i = 0; i < 5; i++) {
      const periodStart = new Date(
        periodEnd.getFullYear(),
        periodEnd.getMonth(),
        1
      );
      const payDay = new Date(
        periodEnd.getFullYear(),
        periodEnd.getMonth() + 1,
        15
      );

      newTableData.push({
        payPeriods: `${formatDateLocal(periodStart)} to ${formatDateLocal(
          periodEnd
        )}`,
        payDays: formatDateLocal(payDay),
      });

      // Ensure periodEnd stays within the month — prevent invalid dates like Feb 30
      periodEnd = getSafeDate(
        periodEnd.getFullYear(),
        periodEnd.getMonth() + 1,
        dayOfMonth
      );
    }

    const firstPayDay = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth() + 1,
      15
    );
    handleChange("payDay", firstPayDay);

    setTableData(newTableData);
  };
useEffect(() => {
  if (isEditMode && initialData) {
    handleChange("profileName", initialData.name);
    handleChange("payCycle", initialData.payCycle);
  }
}, [isEditMode, initialData]);

  return (
    <Modal
      title={"Salary profile configurations"}
      onClose={handleCancelData}
      isOpen={isOpen}
      width="max-w-6xl"
    >
      <div>
        <div className="grid grid-cols-2 mt-4 gap-x-6 gap-y-4 max-w-3xl">
          <FormFieldSet
            type="text"
            title={"Profile Name"}
            placeholder="Enter Profile Name"
            value={formData.profileName}
            onChange={(value) => handleChange("profileName", value)}
            error={errors.profileName}
          />
          <FormFieldSet
            type="select"
            title={"Pay Cycle"}
            placeholder="Enter Pay Cycle"
            value={formData.payCycle}
            onChange={(value) => handleChange("payCycle", value)}
            error={errors.payCycle}
            options={SalaryProfileCycles}
            // disabled={isEditMode}
          />
          {/* <FormFieldSet
            type="datepicker"
            title={"Last Day of the Pay Cycle"}
            placeholder="Select Date"
            value={formData.lastDayOfthePayCycle}
            onChange={(value) => handleLastDayOfThePayCycle(value) }
            error={errors.lastDayOfthePayCycle}
          />
          <FormFieldSet
            type="datepicker"
            title={"Pay Day"}
            placeholder="Select Pay Day"
            value={formData.payDay}
            onChange={(value) => handleChange("payDay", value)}
            error={errors.payDay}
            disabled={true}
          /> */}
        </div>

        {/* <p className="mt-3">
          In case of salaried employees how do you calculate the pay cycle’s
          payable days?
        </p>
        <FormFieldSet
          type="radio"
          title={""}
          placeholder="Select Pay Day"
          options={[
            {
              label:
                "All days in paycycle are payable (weekends and holidays are paid)",
              value: 1,
            },
            {
              label:
                "Only working days are payable (weekends and holidays are not paid)",
              value: 2,
            },
            {
              label:
                "Only working days and calendar holidays are payable (Weekends not paid)",
              value: 3,
            },
          ]}
          value={formData.employeePayableDays}
          name="Payable days"
          onChange={(e) => handleChange("employeePayableDays", e.target.value)}
          className="flex-col"
        />

        <p className="mt-4">
          Coming Pay Days and Pay Periods based on the configurations
        </p> */}
        {/* <NewTable
          rows={tableData}
          columns={columns}
          toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        /> */}

        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={handleCancelData} />
          <Button
            title={isEditMode ? "Update" : "Create"}
            onClick={handleSave}
          />
        </div>
      </div>
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </Modal>
  );
};

export default SalaryprofileConfigurationsModal;
